(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("rxjs/add/operator/takeUntil"), require("rxjs/Subject"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "rxjs/add/operator/takeUntil", "rxjs/Subject"], factory);
	else if(typeof exports === 'object')
		exports["angularTextInputAutocomplete"] = factory(require("@angular/core"), require("@angular/common"), require("rxjs/add/operator/takeUntil"), require("rxjs/Subject"));
	else
		root["angularTextInputAutocomplete"] = factory(root["ng"]["core"], root["ng"]["common"], root["Rx"], root["Rx"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Subject_1 = __webpack_require__(8);
var TextInputAutocompleteMenuComponent = /** @class */ (function () {
    function TextInputAutocompleteMenuComponent() {
        this.closeMenu = new core_1.EventEmitter();
        this.selectChoice = new Subject_1.Subject();
        this.choiceLoading = false;
        this.startingY = 0;
        this.endY = 0;
        this.currentY = 0;
        this.itemHeight = 0;
        this.viewHeight = 0;
    }
    Object.defineProperty(TextInputAutocompleteMenuComponent.prototype, "choices", {
        get: function () {
            return this._choices;
        },
        set: function (choices) {
            this._choices = choices;
            if (choices.indexOf(this.activeChoice) === -1 && choices.length > 0) {
                this.activeChoice = choices[1];
            }
        },
        enumerable: true,
        configurable: true
    });
    TextInputAutocompleteMenuComponent.prototype.onArrowDown = function (event) {
        event.preventDefault();
        var index = this.choices.indexOf(this.activeChoice);
        if (this.itemHeight === 0 && this.dropdown.nativeElement.children[0]) {
            this.itemHeight = this.dropdown.nativeElement.children[0].clientHeight;
            this.viewHeight =
                this.dropdown.nativeElement.clientHeight - this.itemHeight * 3;
            this.currentY = -this.viewHeight;
        }
        this.currentY += this.itemHeight;
        if (this.endY === 0 || this.currentY < this.endY) {
            this.dropdown.nativeElement.scrollTo(0, this.currentY);
        }
        if (this.choices[index + 1]) {
            if (this.choices[index + 1].startsWith('---')) {
                if (this.choices[index + 2]) {
                    this.activeChoice = this._choices[index + 2];
                }
            }
            else {
                this.activeChoice = this._choices[index + 1];
            }
        }
        else {
            this.endY = this.currentY;
        }
    };
    TextInputAutocompleteMenuComponent.prototype.onArrowUp = function (event) {
        event.preventDefault();
        var index = this.choices.indexOf(this.activeChoice);
        if (this.itemHeight === 0 && this.dropdown.nativeElement.children[0]) {
            this.itemHeight = this.dropdown.nativeElement.children[0].clientHeight;
            this.viewHeight =
                this.dropdown.nativeElement.clientHeight - this.itemHeight * 3;
        }
        if (this.currentY < 0) {
            this.currentY = -this.viewHeight;
        }
        else {
            this.currentY -= this.itemHeight;
            this.dropdown.nativeElement.scrollTo(0, this.currentY);
        }
        if (this.choices[index - 1]) {
            if (this.choices[index - 1].startsWith('---')) {
                if (this.choices[index - 2]) {
                    this.activeChoice = this._choices[index - 2];
                }
                else {
                    // do nothing
                }
            }
            else {
                this.activeChoice = this._choices[index - 1];
            }
        }
    };
    TextInputAutocompleteMenuComponent.prototype.onEnter = function (event) {
        if (this.choices.indexOf(this.activeChoice) > -1) {
            event.preventDefault();
            this.selectChoice.next(this.activeChoice);
        }
    };
    TextInputAutocompleteMenuComponent.prototype.onEscPress = function (e) {
        this.closeMenu.emit();
    };
    __decorate([
        core_1.ViewChild('inputACMenu'),
        __metadata("design:type", core_1.ElementRef)
    ], TextInputAutocompleteMenuComponent.prototype, "dropdown", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteMenuComponent.prototype, "closeMenu", void 0);
    __decorate([
        core_1.HostListener('document:keydown.ArrowDown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteMenuComponent.prototype, "onArrowDown", null);
    __decorate([
        core_1.HostListener('document:keydown.ArrowUp', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteMenuComponent.prototype, "onArrowUp", null);
    __decorate([
        core_1.HostListener('document:keydown.Enter', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteMenuComponent.prototype, "onEnter", null);
    __decorate([
        core_1.HostListener('document:keydown.Escape', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteMenuComponent.prototype, "onEscPress", null);
    TextInputAutocompleteMenuComponent = __decorate([
        core_1.Component({
            template: "\n    <ul #inputACMenu\n      *ngIf=\"choices?.length > 0\"\n      class=\"dropdown-menu\"\n      [style.top.px]=\"position?.top\"\n      [style.left.px]=\"position?.left\">\n      <li \n        *ngFor=\"let choice of choices\"\n        [ngStyle] = \"{'background-color': choice.startsWith('---') ? '#E0EFF6' : 'auto', \n                    'color': choice.startsWith('---') ? 'black' : 'auto'}\"\n        [class.active]=\"activeChoice === choice\">\n        <a\n          href=\"javascript:;\"\n          (click)=\"selectChoice.next(choice)\">\n          {{ choice }}\n        </a>\n      </li>\n    </ul>\n  ",
            styles: [
                "\n    .dropdown-menu {\n      display: block;\n      overflow: auto;\n      height: 200px;\n      resize: both;\n    }\n  "
            ]
        })
    ], TextInputAutocompleteMenuComponent);
    return TextInputAutocompleteMenuComponent;
}());
exports.TextInputAutocompleteMenuComponent = TextInputAutocompleteMenuComponent;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(3));
var text_input_autocomplete_menu_component_1 = __webpack_require__(1);
exports.TextInputAutocompleteMenuComponent = text_input_autocomplete_menu_component_1.TextInputAutocompleteMenuComponent;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(4);
var text_input_autocomplete_directive_1 = __webpack_require__(5);
var text_input_autocomplete_container_component_1 = __webpack_require__(9);
var text_input_autocomplete_menu_component_1 = __webpack_require__(1);
var TextInputAutocompleteModule = /** @class */ (function () {
    function TextInputAutocompleteModule() {
    }
    TextInputAutocompleteModule = __decorate([
        core_1.NgModule({
            declarations: [
                text_input_autocomplete_directive_1.TextInputAutocompleteDirective,
                text_input_autocomplete_container_component_1.TextInputAutocompleteContainerComponent,
                text_input_autocomplete_menu_component_1.TextInputAutocompleteMenuComponent
            ],
            imports: [common_1.CommonModule],
            exports: [
                text_input_autocomplete_directive_1.TextInputAutocompleteDirective,
                text_input_autocomplete_container_component_1.TextInputAutocompleteContainerComponent,
                text_input_autocomplete_menu_component_1.TextInputAutocompleteMenuComponent
            ],
            entryComponents: [text_input_autocomplete_menu_component_1.TextInputAutocompleteMenuComponent]
        })
    ], TextInputAutocompleteModule);
    return TextInputAutocompleteModule;
}());
exports.TextInputAutocompleteModule = TextInputAutocompleteModule;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var getCaretCoordinates = __webpack_require__(6);
__webpack_require__(7);
var text_input_autocomplete_menu_component_1 = __webpack_require__(1);
var TextInputAutocompleteDirective = /** @class */ (function () {
    function TextInputAutocompleteDirective(componentFactoryResolver, viewContainerRef, injector, elm) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.viewContainerRef = viewContainerRef;
        this.injector = injector;
        this.elm = elm;
        /**
         * The character that will trigger the menu to appear
         */
        this.triggerCharacter = '@';
        /**
         * The regular expression that will match the search text after the trigger character
         */
        this.searchRegexp = /^\w*$/;
        /**
         * The menu component to show with available options.
         * You can extend the built in `TextInputAutocompleteMenuComponent` component to use a custom template
         */
        this.menuComponent = text_input_autocomplete_menu_component_1.TextInputAutocompleteMenuComponent;
        /**
         * Called when the options menu is shown
         */
        this.menuShown = new core_1.EventEmitter();
        /**
         * Called when the options menu is hidden
         */
        this.menuHidden = new core_1.EventEmitter();
        /**
         * Called when a choice is selected
         */
        this.choiceSelected = new core_1.EventEmitter();
        /**
         * A function that formats the selected choice once selected.
         */
        this.getChoiceLabel = function (choice) { return choice; };
    }
    TextInputAutocompleteDirective.prototype.onKeypress = function (e) {
        if (e.key === this.triggerCharacter) {
            this.showMenu();
        }
    };
    TextInputAutocompleteDirective.prototype.onChange = function (value) {
        var _this = this;
        if (this.menu) {
            if (value[this.menu.triggerCharacterPosition] !== this.triggerCharacter) {
                this.hideMenu();
            }
            else {
                var cursor = this.elm.nativeElement.selectionStart;
                if (cursor < this.menu.triggerCharacterPosition) {
                    this.hideMenu();
                }
                else {
                    var searchText = value.slice(this.menu.triggerCharacterPosition + 1, cursor);
                    if (!searchText.match(this.searchRegexp)) {
                        this.hideMenu();
                    }
                    else {
                        this.menu.component.instance.searchText = searchText;
                        this.menu.component.instance.choices = [];
                        this.menu.component.instance.choiceLoadError = undefined;
                        this.menu.component.instance.choiceLoading = true;
                        this.menu.component.changeDetectorRef.detectChanges();
                        Promise.resolve(this.findChoices(searchText))
                            .then(function (choices) {
                            if (_this.menu) {
                                _this.menu.component.instance.choices = choices;
                                _this.menu.component.instance.choiceLoading = false;
                                _this.menu.component.changeDetectorRef.detectChanges();
                            }
                        })
                            .catch(function (err) {
                            if (_this.menu) {
                                _this.menu.component.instance.choiceLoading = false;
                                _this.menu.component.instance.choiceLoadError = err;
                                _this.menu.component.changeDetectorRef.detectChanges();
                            }
                        });
                    }
                }
            }
        }
    };
    TextInputAutocompleteDirective.prototype.onBlur = function () {
        if (this.menu) {
            this.menu.lastCaretPosition = this.elm.nativeElement.selectionStart;
        }
    };
    TextInputAutocompleteDirective.prototype.showMenu = function () {
        var _this = this;
        if (!this.menu) {
            var menuFactory = this.componentFactoryResolver.resolveComponentFactory(this.menuComponent);
            this.menu = {
                component: this.viewContainerRef.createComponent(menuFactory, 0, this.injector),
                triggerCharacterPosition: this.elm.nativeElement.selectionStart
            };
            var lineHeight = +getComputedStyle(this.elm.nativeElement)
                .lineHeight.replace(/px$/, '');
            var _a = getCaretCoordinates(this.elm.nativeElement, this.elm.nativeElement.selectionStart), top_1 = _a.top, left = _a.left;
            this.menu.component.instance.position = {
                top: top_1 + lineHeight,
                left: left
            };
            this.menu.component.changeDetectorRef.detectChanges();
            this.menu.component.instance.closeMenu.subscribe(function (result) {
                _this.hideMenu();
            });
            this.menu.component.instance.selectChoice
                .takeUntil(this.menuHidden)
                .subscribe(function (choice) {
                var label = _this.getChoiceLabel(choice);
                var textarea = _this.elm.nativeElement;
                var value = textarea.value;
                var startIndex = _this.menu.triggerCharacterPosition;
                var start = value.slice(0, startIndex);
                var caretPosition = _this.menu.lastCaretPosition || textarea.selectionStart;
                var end = value.slice(caretPosition);
                textarea.value = start + label + end;
                // force ng model / form control to update
                textarea.dispatchEvent(new Event('input'));
                _this.hideMenu();
                var setCursorAt = (start + label).length;
                textarea.setSelectionRange(setCursorAt, setCursorAt);
                textarea.focus();
                _this.choiceSelected.emit({
                    choice: choice,
                    insertedAt: {
                        start: startIndex,
                        end: startIndex + label.length
                    }
                });
            });
            this.menuShown.emit();
        }
    };
    TextInputAutocompleteDirective.prototype.hideMenu = function () {
        if (this.menu) {
            this.menu.component.destroy();
            this.menuHidden.emit();
            this.menu = undefined;
        }
    };
    TextInputAutocompleteDirective.prototype.ngOnDestroy = function () {
        this.hideMenu();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteDirective.prototype, "triggerCharacter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteDirective.prototype, "searchRegexp", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteDirective.prototype, "menuComponent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteDirective.prototype, "menuShown", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteDirective.prototype, "menuHidden", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], TextInputAutocompleteDirective.prototype, "choiceSelected", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], TextInputAutocompleteDirective.prototype, "findChoices", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], TextInputAutocompleteDirective.prototype, "getChoiceLabel", void 0);
    __decorate([
        core_1.HostListener('keypress', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteDirective.prototype, "onKeypress", null);
    __decorate([
        core_1.HostListener('input', ['$event.target.value']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteDirective.prototype, "onChange", null);
    __decorate([
        core_1.HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextInputAutocompleteDirective.prototype, "onBlur", null);
    TextInputAutocompleteDirective = __decorate([
        core_1.Directive({
            selector: 'textarea[mwlTextInputAutocomplete],input[type="text"][mwlTextInputAutocomplete]'
        }),
        __metadata("design:paramtypes", [core_1.ComponentFactoryResolver,
            core_1.ViewContainerRef,
            core_1.Injector,
            core_1.ElementRef])
    ], TextInputAutocompleteDirective);
    return TextInputAutocompleteDirective;
}());
exports.TextInputAutocompleteDirective = TextInputAutocompleteDirective;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* jshint browser: true */

(function () {

// The properties that we copy into a mirrored div.
// Note that some browsers, such as Firefox,
// do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
// so we have to do every single property specifically.
var properties = [
  'direction',  // RTL support
  'boxSizing',
  'width',  // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
  'height',
  'overflowX',
  'overflowY',  // copy the scrollbar for IE

  'borderTopWidth',
  'borderRightWidth',
  'borderBottomWidth',
  'borderLeftWidth',
  'borderStyle',

  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',

  // https://developer.mozilla.org/en-US/docs/Web/CSS/font
  'fontStyle',
  'fontVariant',
  'fontWeight',
  'fontStretch',
  'fontSize',
  'fontSizeAdjust',
  'lineHeight',
  'fontFamily',

  'textAlign',
  'textTransform',
  'textIndent',
  'textDecoration',  // might not make a difference, but better be safe

  'letterSpacing',
  'wordSpacing',

  'tabSize',
  'MozTabSize'

];

var isBrowser = (typeof window !== 'undefined');
var isFirefox = (isBrowser && window.mozInnerScreenX != null);

function getCaretCoordinates(element, position, options) {
  if(!isBrowser) {
    throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
  }

  var debug = options && options.debug || false;
  if (debug) {
    var el = document.querySelector('#input-textarea-caret-position-mirror-div');
    if ( el ) { el.parentNode.removeChild(el); }
  }

  // mirrored div
  var div = document.createElement('div');
  div.id = 'input-textarea-caret-position-mirror-div';
  document.body.appendChild(div);

  var style = div.style;
  var computed = window.getComputedStyle? getComputedStyle(element) : element.currentStyle;  // currentStyle for IE < 9

  // default textarea styles
  style.whiteSpace = 'pre-wrap';
  if (element.nodeName !== 'INPUT')
    style.wordWrap = 'break-word';  // only for textarea-s

  // position off-screen
  style.position = 'absolute';  // required to return coordinates properly
  if (!debug)
    style.visibility = 'hidden';  // not 'display: none' because we want rendering

  // transfer the element's properties to the div
  properties.forEach(function (prop) {
    style[prop] = computed[prop];
  });

  if (isFirefox) {
    // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
    if (element.scrollHeight > parseInt(computed.height))
      style.overflowY = 'scroll';
  } else {
    style.overflow = 'hidden';  // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
  }

  div.textContent = element.value.substring(0, position);
  // the second special handling for input type="text" vs textarea: spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
  if (element.nodeName === 'INPUT')
    div.textContent = div.textContent.replace(/\s/g, '\u00a0');

  var span = document.createElement('span');
  // Wrapping must be replicated *exactly*, including when a long word gets
  // onto the next line, with whitespace at the end of the line before (#7).
  // The  *only* reliable way to do that is to copy the *entire* rest of the
  // textarea's content into the <span> created at the caret position.
  // for inputs, just '.' would be enough, but why bother?
  span.textContent = element.value.substring(position) || '.';  // || because a completely empty faux span doesn't render at all
  div.appendChild(span);

  var coordinates = {
    top: span.offsetTop + parseInt(computed['borderTopWidth']),
    left: span.offsetLeft + parseInt(computed['borderLeftWidth'])
  };

  if (debug) {
    span.style.backgroundColor = '#aaa';
  } else {
    document.body.removeChild(div);
  }

  return coordinates;
}

if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
  module.exports = getCaretCoordinates;
} else if(isBrowser){
  window.getCaretCoordinates = getCaretCoordinates;
}

}());


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var TextInputAutocompleteContainerComponent = /** @class */ (function () {
    function TextInputAutocompleteContainerComponent() {
    }
    TextInputAutocompleteContainerComponent = __decorate([
        core_1.Component({
            selector: 'mwl-text-input-autocomplete-container',
            styles: [
                "\n    :host {\n      position: relative;\n      display: block;\n    }\n  "
            ],
            template: '<ng-content></ng-content>'
        })
    ], TextInputAutocompleteContainerComponent);
    return TextInputAutocompleteContainerComponent;
}());
exports.TextInputAutocompleteContainerComponent = TextInputAutocompleteContainerComponent;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// angular-text-input-autocomplete.umd.min.js